export default (state = {}, action) => {
  switch (action.type) {
    case 'SET_ORDER_FILTERS': {
      return {
        ...state,
        orderFilters: action.data,
      };
    }
    case 'SET_ORDER_FILTER_FLAG': {
      return {
        ...state,
        activeFilter: action.data,
      };
    }
    default: {
      return state;
    }
  }
};
